<template>
  <div id="socialMedia">
    <v-form ref="formEdit">
      <v-layout class="mt-1 mb-2 mt-2">
        <div class="ml-2 mb-0 pf-font-18 wrap-break-word pf-border-teal-dash-2 pl-3 pt-2 pr-3 pb-2">
          <h3>Safety Tip</h3>
          <p class="pf-text-warning pf-font-16">Keep your own personal privacy in mind when linking to social media pages. While most adoption situations play out in a safe manner, scams do happen. Consider using adoption-specific social media accounts, so as not to expose you and your loved ones to unwanted direct contact.</p>
        </div>
      </v-layout>
      <v-container>
        <h4 class="mb-3 font-weight-regular">Links to use in YOUR social media</h4>
        <v-layout wrap row align-center class="mb-3">
            <v-flex xs1 align-center>
              <v-btn icon depressed color="pf-bg-teal">
                <v-icon size="18" class="icon-color">menu_book</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs11>
              <p class="ml-2 mb-0 pf-font-16">
                Profile Book - Agency: 
                <select
                  v-model="selectedAgency"
                  placeholder="Select Agency"
                  class="custom-select"
                  @change="onChangeAgency"
                >
                  <option v-for="agency in getAgencyList" :key="agency.id" :value="agency.id">
                    {{ agency.name }}
                  </option>
                </select>
                <a :href="getFlipbookURL" class="wrap-break-word" v-if="getFlipbookURL" target="_blank">{{ getFlipbookURL }}</a>
                <span v-else class="bg-redish">No profile book found</span>
                <v-btn icon fab class="pf-text-teal ma-0"
                  title="Copy URL"
                  v-if="getFlipbookURL"
                  v-clipboard:copy="getFlipbookURL"
                  v-clipboard:success="onCopySuccess"
                  v-clipboard:error="{}">
                  <v-icon size="20" class="pr-1">file_copy</v-icon>
                </v-btn>
                <v-btn icon fab class="pf-text-teal ma-0"
                  v-if="getFlipbookURL && selectedAgency && isConfigAllowed"
                  title="Configure"
                  @click="configureFlipbook()"
                >
                  <v-icon size="20" class="pr-1">settings</v-icon>
                </v-btn>
              </p>
              <span class="pf-text-red" v-if="profileBookWarning">{{ profileBookWarning }}</span>
            </v-flex>
        </v-layout>
        <v-layout wrap row align-center :class="{ 'mb-3': Account.membership !== 'Network' }">
            <v-flex xs1 align-center>
                <v-btn icon depressed color="pf-bg-pink">
                  <v-icon size="18" class="icon-color">link</v-icon>
                </v-btn>
            </v-flex>
            <v-flex xs11>
                <p class="ml-2 mb-0 pf-font-16">
                  Profile - <a :href="getFamilyBadgeURL" class="wrap-break-word" v-if="getFamilyBadgeURL" target="_blank">{{ getFamilyBadgeURL }}</a>
                  <span v-else class="bg-redish">No badge profile found</span>
                  <v-btn icon fab class="pf-text-teal ma-0"
                    v-if="getFamilyBadgeURL"
                    v-clipboard:copy="getFamilyBadgeURL"
                    v-clipboard:success="onCopySuccess"
                    v-clipboard:error="{}">
                    <v-icon size="20" class="pr-1">file_copy</v-icon>
                  </v-btn>
                </p>
            </v-flex>
        </v-layout>
        <v-layout wrap row align-center v-if="Account.membership !== 'Network'">
            <v-flex xs1 align-center>
                <v-btn icon depressed color="pf-bg-green">
                <v-icon size="18" class="icon-color">language</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs11>
                <p class="ml-2 mb-0 pf-font-16">
                  Website - <a :href="getFamilyURL" class="wrap-break-word" v-if="getFamilyURL" target="_blank">{{ getFamilyURL }}</a>
                  <span v-else class="bg-redish">No website found</span>
                  <v-btn icon fab class="pf-text-teal ma-0"
                    v-if="getFamilyURL"
                    v-clipboard:copy="getFamilyURL"
                    v-clipboard:success="onCopySuccess"
                    v-clipboard:error="{}">
                    <v-icon size="20" class="pr-1">file_copy</v-icon>
                  </v-btn>
                </p>
            </v-flex>
        </v-layout>

        <br />
        <hr class="mb-3 pf-hr" />
        
        <h4 class="mb-3 font-weight-regular">Links to social media</h4>
        <v-layout wrap row align-center>
            <v-flex md1 sm2 xs3 align-center>
                <v-btn icon depressed color="bg-facebook">
                    <v-icon size="17" class="icon-color">fa fa-facebook</v-icon>
                </v-btn>
            </v-flex>
            <v-flex md6 sm8 xs6>
               <v-text-field spellcheck="false" hint="https://facebook.com/username" :rules="[rules.URLRules, rules.facebookRule]" @input="dirty=true" v-model="socialAccount.social.facebook.url" label="Enter URL">
            </v-text-field>
            </v-flex>
        </v-layout>
         <v-layout wrap row align-center>
            <v-flex md1 sm2 xs3 align-center>
                <v-btn icon depressed color="bg-tiktok">
                    <v-icon size="17" class="icon-color">tiktok</v-icon>
                </v-btn>
            </v-flex>
            <v-flex md6 sm8 xs6>
               <v-text-field spellcheck="false" hint="https://tiktok.com/username" :rules="[rules.URLRules, rules.ticktokRule]" @input="dirty=true" v-model="socialAccount.social.tiktok.url" label="Enter URL">
            </v-text-field>
            </v-flex>
        </v-layout>
         <v-layout wrap row align-center>
            <v-flex md1 sm2 xs3 align-center>
                <v-btn icon depressed color="bg-twitter">
                    <v-icon size="17" class="icon-color">fab fa-twitter</v-icon>
                </v-btn>
            </v-flex>
            <v-flex md6 sm8 xs6>
              <v-text-field spellcheck="false" hint="https://twitter.com/username" :rules="[rules.URLRules, rules.twitterRule]" @input="dirty=true" v-model="socialAccount.social.twitter.url" label="Enter URL">
              </v-text-field>
            </v-flex>
        </v-layout>
         <v-layout wrap row align-center>
            <v-flex md1 sm2 xs3 align-center>
                <v-btn icon depressed color="bg-blogger">
                    <v-icon size="17" class="icon-color">fab fa-blogger-b</v-icon>
                </v-btn>
            </v-flex>
            <v-flex md6 sm8 xs6>
               <v-text-field spellcheck="false" hint="https://blogger.com/username" :rules="[rules.URLRules, rules.bloggerRule]" @input="dirty=true" v-model="socialAccount.social.blogger.url" label="Enter URL">
            </v-text-field>
            </v-flex>
        </v-layout>
           <v-layout wrap row align-center>
            <v-flex md1 sm2 xs3 align-center>
                <v-btn icon depressed color="bg-instagram">
                    <v-icon size="17" class="icon-color">fab fa-instagram</v-icon>
                </v-btn>
            </v-flex>
            <v-flex md6 sm8 xs6>
                <v-text-field spellcheck="false" hint="https://instagram.com/username" :rules="[rules.URLRules, rules.instagramRule]" @input="dirty=true" v-model="socialAccount.social.instagram.url" label="Enter URL">
                </v-text-field>
            </v-flex>
        </v-layout>
           <v-layout wrap row align-center pb-5>
            <v-flex md1 sm2 xs3 align-center>
                <v-btn icon depressed color="bg-pinterest">
                    <v-icon size="17" class="icon-color">fab fa-pinterest-p</v-icon>
                </v-btn>
            </v-flex>
            <v-flex md6 sm8 xs6>
                <v-text-field spellcheck="false" hint="https://pinterest.com/username" :rules="[rules.URLRules, rules.pintrestRule]" @input="dirty=true" v-model="socialAccount.social.pinterest.url" label="Enter URL">
                </v-text-field>
            </v-flex>
        </v-layout>
        
        <v-layout class="button-container pr-4" :class="{'pl-4': $vuetify.breakpoint.smAndUp}"> 
          <v-flex xs12 sm12 md12 class="pr-0 text-xs-right" v-if="dirty">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>
<script>
/* global session store */
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { getOne, update, getCollection } from '../helpers/helpers';
import swal from 'sweetalert2';
import VueClipboard from 'vue-clipboard2';
import { configure } from 'nprogress';
Vue.use(VueClipboard);

export default {
  name: 'social-media',
  components: {

  },
  data: () => ({
    accountDetails: {},
    socialAccount: {
      social: {
        facebook: {
          url: '',
          active: true
        },
        /* google: {
          url: '',
          active: true
        }, */
        tiktok: {
          url: '',
          active: true
        },
        twitter: {
          url: '',
          active: true
        },
        blogger: {
          url: '',
          active: true
        },
        instagram: {
          url: '',
          active: true
        },
        pinterest: {
          url: '',
          active: true
        }
      }
    },
    dirty: false,
    facebook: '',
    rules: {
      URLRules: (v) => v === '' || /^$|(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g.test(v) || 'Please enter valid URL Address',
      facebookRule: (v) => v === '' || /^(https?:\/\/)?(www\.)?facebook.com\/[a-zA-Z0-9(\.\?)?]/g.test(v) || 'Please enter a valid facebook link',
      googleRule: (v) => v === '' || /^(https?:\/\/)?(www\.)?plus.google.com\/[a-zA-Z0-9(\.\?)?]/g.test(v) || 'Please enter a valid google plus link',
      ticktokRule: (v) => v === '' || /^(https?:\/\/)?(www\.)?tiktok.com\/[a-zA-Z0-9(\.\?)?]/g.test(v) || 'Please enter a valid tiktok link',
      twitterRule: (v) => v === '' || /^(https?:\/\/)?(www\.)?twitter.com\/[a-zA-Z0-9(\.\?)?]/g.test(v) || 'Please enter a valid twitter link',
      bloggerRule: (v) => v === '' || /^(https?:\/\/)?(www\.)?blogger.com\/[a-zA-Z0-9(\.\?)?]/g.test(v) || 'Please enter a valid blogger link',
      instagramRule: (v) => v === '' || /^(https?:\/\/)?(www\.)?instagram.com\/[a-zA-Z0-9(\.\?)?]/g.test(v) || 'Please enter a valid instagram link',
      pintrestRule: (v) => v === '' || /^(https?:\/\/)?(www\.)?pinterest.com\/[a-zA-Z0-9(\.\?)?]/g.test(v) || 'Please enter a valid pinterest link',
    },
    selectedAgency: null,
    profileBookWarning: null
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters(['Account', 'MyAgencies']),
    getAgencyList () {
      return (this.MyAgencies || []).map(agency => {
        return {
          id: agency._id,
          name: agency.name
        };
      });
    },
    getFlipbookURL () {
      /* eslint-disable */
      const pdfTemplate = this.selectedAgency ? this.reversePDFTemplate.find(template => {
        return template.agency && template.agency.length && template.agency.includes(this.selectedAgency);
      }) : null;
      let flipbook = pdfTemplate ? this.Account.flipbook.find(fb => fb.pdf_template === pdfTemplate.id) : null;

      if (flipbook) {
        if (flipbook.heyzine_data && flipbook.heyzine_data.url) {
          return flipbook.heyzine_data.url;
        } else if (flipbook.flipbook) {
          // If flipbook is present, construct the URL
          return config.uploadPath + flipbook.flipbook;
        }
      }
      return null;
    },
    isConfigAllowed () {

      try {
        const pdfTemplate = this.reversePDFTemplate.find(template => {
          return template.agency && template.agency.length && template.agency.includes(this.selectedAgency);
        });
        const flipbook = pdfTemplate ? this.Account.flipbook.find(fb => fb.pdf_template === pdfTemplate.id) : null;
  
        return flipbook && flipbook.heyzine_data && flipbook.heyzine_data.url && flipbook.heyzine_data.id ? true : false;
      } catch (e) {
        return false;
      }
    },
    getFamilyURL () {
      /* eslint-disable */
      let URL = this.Account.contactInfo && this.Account.contactInfo.website ? this.Account.contactInfo.website : null;
      return URL ? (URL.indexOf('http') > -1 ? URL : ('https://' + URL)) : null;
    },
    getFamilyBadgeURL () {
      /* eslint-disable */
      return `${config.profileDomain}view/profile/${this.Account.nickname}`;
    },
    PdfTemplate: {
      get () {
        return store.state.PdfTemplate;
      },
      set (value) {
        store.commit('setPdfTemplate', value);
      }
    },
    reversePDFTemplate () {
      return [...this.PdfTemplate].reverse();
    },
    DefaultAgency: {
      set (value) {
        store.commit('setDefaultAgency', value);
      },
      get () {
        return store.state.DefaultAgency;
      }
    }
  },
  async created () {
    this.getLinks();
    await this.fetchAgency();
    await this.templateIntilize();
    this.selectedAgency = this.Account.default_agency || (this.Account.agency && this.Account.agency.length ? this.Account.agency[0].agency : null);
    this.onChangeAgency();
  },
  methods: {
    async save () {
      if (this.$refs.formEdit.validate()) {
        this.dirty = false;
        this.accountDetails.social = this.socialAccount.social;
        this.accountDetails.updated_from = 'socialMedia';
        let entity = `Account`;
        let { error, data, status } = await update(entity, this.accountDetails, session.getSession().adminUser ? session.getSession().user.human.account.id : 'Me');
        if (error) {
          this.dirty = true;
          console.log('error', error);
        } else {
          this.loading = false;
          this.Account.social = this.accountDetails.social;
          swal.fire({
            type: 'success',
            title: 'Social media details updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.dirty = false;
            }
          });
        }
      }
    },
    async fetchAgency () {
      if (!Object.keys(this.DefaultAgency).length && this.Account && this.Account.default_agency) {
        let { error, data } = await getOne('Agency', this.Account.default_agency, '', '-account');
        if (error) {
          console.log(error);
        } else {
          this.DefaultAgency = data;
        }
      }
    },
    onCopySuccess () {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Copied to clipboard'
      };
    },
    hideButtons () {
      this.dirty = false;
      this.getLinks();
    },
    getLinks () {
      this.accountDetails = JSON.parse(JSON.stringify(this.Account));
      this.socialAccount.social = {
        facebook: this.accountDetails.social && this.accountDetails.social.facebook ? this.accountDetails.social.facebook : { url: '', active: true },
        // google: this.accountDetails.social && this.accountDetails.social.google ? this.accountDetails.social.google : { url: '', active: true },
        tiktok: this.accountDetails.social && this.accountDetails.social.tiktok ? this.accountDetails.social.tiktok : { url: '', active: true },
        twitter: this.accountDetails.social && this.accountDetails.social.twitter ? this.accountDetails.social.twitter : { url: '', active: true },
        blogger: this.accountDetails.social && this.accountDetails.social.blogger ? this.accountDetails.social.blogger : { url: '', active: true },
        instagram: this.accountDetails.social && this.accountDetails.social.instagram ? this.accountDetails.social.instagram : { url: '', active: true },
        pinterest: this.accountDetails.social && this.accountDetails.social.pinterest ? this.accountDetails.social.pinterest : { url: '', active: true },
      };
    },
    configureFlipbook () {
      const pdfTemplate = this.reversePDFTemplate.find(template => {
        return template.agency && template.agency.length && template.agency.includes(this.selectedAgency);
      });
      this.$router.push({ name: 'Flipbook', params: { pdfTemplateId: pdfTemplate.id || null } });
    },
    async templateIntilize () {
      // Initialize PDF templates
      if (!this.PdfTemplate.length) {
        let sessionUser = session.getSession();
        let where = {};
        if (sessionUser.adminUser) {
          where.account = sessionUser.user.human.account.id;
        }
        let { error, data, status } = await getCollection('PdfTemplate', true, 0, '', where);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load PdfTemplates'
          };
        } else {
          this.PdfTemplate = data.filter(pdf => {
            if (session.getSession().adminUser && session.getSession().adminUser.role === 'agency') {
              return pdf.agency.findIndex(agency => agency === session.getSession().adminUser.human.agency || (session.getSession().adminUser.human.agency.id && agency === session.getSession().adminUser.human.agency.id)) !== -1;
            }
            return true;
          });
        }
      }
    },
    onChangeAgency () {
      // Check if the selected agency has heyzine flipbook and set a warning if no thumbnail is found
      this.profileBookWarning = null;
      if (this.selectedAgency) {
        const pdfTemplate = this.reversePDFTemplate.find(template => {
          return template.agency && template.agency.length && template.agency.includes(this.selectedAgency);
        });
        const flipbook = pdfTemplate ? this.Account.flipbook.find(fb => fb.pdf_template === pdfTemplate.id) : null;
        if (flipbook && flipbook.heyzine_data && (!flipbook.heyzine_data.social_metadata || (flipbook.heyzine_data.social_metadata && !flipbook.heyzine_data.social_metadata.thumbnail))) {
          this.profileBookWarning = '🔴 Please note that the profile book for this agency does not have a thumbnail image set. It may not display correctly on social media. You can click on the settings icon to configure it.';
        }
      }
    }
  }
};
</script>


<style scoped>

.v-btn--icon {
  border-radius: 0;
}
.icon-color {
    color: #fff !important;
}
.border {
  border: 1px solid grey;
}
@media(max-width:410px){
  .pf-btn{
    min-width: 85px;
  }
}
.custom-select {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0 3px;
  font-size: 14px;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/pages/SocialMedia.vue